import { companyName } from '@app/configs'
import { generateStrings } from '../../strings'

const appName = companyName

export const strings = generateStrings({
  appName,
  meta: {
    title: `${appName}: the open source web accessibility tool.`,
    description: `Build accessible websites with tools that monitor, fix, and guide web accessibility efficiency with ${appName}`,
  },
})
